<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 d-inline-block mb-0">Technical Database</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-8 col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                                <hikariDetail></hikariDetail>
                            </div>
                            <div class="col-md-12">
                                <aqcuireDetail></aqcuireDetail>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                                <jdbcDetail></jdbcDetail>
                            </div>
                            <div class="col-md-12">
                                <card header-classes="bg-transparent">
                                    <template v-slot:header>
                                        <h5 class="h3 mb-0">Connection Pool Usage</h5>
                                    </template>
                                    <div>
                                        <canvas :height="247" :id="doughnetChartID"></canvas>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="row">
                    <div class="col-md-12">
                        <dataRepoDetail></dataRepoDetail>
                    </div>
                    <div class="col-xl-12">
                        <liquibaseDetail></liquibaseDetail>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import liquibaseDetail from "./LiquibaseDetail";
import cacheDetail from "./CacheDetail";
import jdbcDetail from "./JdbcDetail";
import dashboardCard from "./DashboardCard.vue";
import hikariDetail from "./HikariUsageDetail.vue";
import aqcuireDetail from "./AqcuireUsageDetail.vue";
import dataRepoDetail from "./DataRepoDetail.vue";
export default {
    components: {
        liquibaseDetail,
        cacheDetail,
        jdbcDetail,
        dashboardCard,
        hikariDetail,
        aqcuireDetail,
        dataRepoDetail
    },
    data() {
        return {
            active: "",
            creation: "",
            idle: "",
            max: "",
            min: "",
            pending: "",
            timeout: "",
            connection: "",
            doughnetChartID: "doughnetChart",
        };
    },
    methods: {
        formatValue(value) {
            return value > 100 ? (value / 1000).toFixed(2) + 'k' : value;
        },
        createDoughnetChart() {
            const ctx = document.getElementById(this.doughnetChartID).getContext("2d");
            if (this.doughnetChart) {
                this.doughnetChart.destroy();
            }
            this.doughnetChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: ["Idle", "Active"],
                    datasets: [
                        {
                            label: "Dataset 1",
                            tension: 0.4,
                            data: [this.idle, this.active],
                            backgroundColor: [
                                "#3b5999",
                                "#2dce89",
                            ],
                            showLine: false,
                            barPercentage: 1.6,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 60,
                    rotation: Math.PI,
                    circumference: 2 * Math.PI,
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            boxWidth: 20,
                            font: { size: 14, weight: "bold" },
                        },
                    },
                    tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                    },
                    scales: {
                        display: false,
                    },
                    pluginLabels: {
                        jdbcMax: this.max,
                        jdbcMin: this.min,
                    },
                    layout: {
                        padding: 0,
                    },
                },
                plugins: [
                    {
                        afterDraw: function (chart) {
                            const { ctx, width, height } = chart;
                            const pluginLabels = chart.options.pluginLabels;
                            const jdbcMax = pluginLabels.jdbcMax || "N/A";
                            const jdbcMin = pluginLabels.jdbcMin || "N/A";
                            const centerText = `${jdbcMax}(max) / ${jdbcMin}(min)`;
                            ctx.font = "bold 13px Open Sans";
                            ctx.textAlign = "center";
                            ctx.textBaseline = "middle";
                            ctx.fillStyle = "#8898aa";
                            const centerX = width / 2;
                            const centerY = height / 2.4;
                            ctx.fillText(centerText, centerX, centerY);
                        },
                    },
                    {
                        id: "sectionLabels",
                        afterDraw: (chart) => {
                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);
                            ctx.font = "bold 14px sans-serif";
                            ctx.textBaseline = "middle";
                            ctx.textAlign = "center";
                            ctx.fillStyle = "#ffffff";
                            meta.data.forEach((element, index) => {
                                const value = chart.data.datasets[0].data[index];
                                if (value > 1) {
                                    const model = element.tooltipPosition();
                                    ctx.fillText(`${value}`, model.x, model.y);
                                }
                            });
                        },
                    },
                ],
            });
        },
        getHikariConnections(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.connection = JSON.parse(response.server.data[0].value);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariActiveInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.active = response.server.data[0].value;
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariCreationInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.creation = response.server.data[0].value;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariIdleInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.idle = response.server.data[0].value;
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariMaxInfo(type) {
            let data = {
                type: type,
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.max = response.server.data[0].value;
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariMinFree(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.min = response.server.data[0].value;
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariPending(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.pending = response.server.data[0].value;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHikariTimeOut(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.timeout = response.server.data[0].value;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.getHikariConnections("HIKARICP_CONNECTIONS");
        this.getHikariActiveInfo("HIKARICP_CONNECTIONS_ACTIVE");
        this.getHikariCreationInfo("HIKARICP_CONNECTIONS_CREATION");
        this.getHikariIdleInfo("HIKARICP_CONNECTIONS_IDLE");
        this.getHikariMaxInfo("HIKARICP_CONNECTIONS_MAX");
        this.getHikariMinFree("HIKARICP_CONNECTIONS_MIN");
        this.getHikariPending("HIKARICP_CONNECTIONS_PENDING");
        this.getHikariTimeOut("HIKARICP_CONNECTIONS_TIMEOUT");
    },
};
</script>
<style></style>
